webpackJsonp([2],{

/***/ 602:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b41249d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__ = __webpack_require__(659);
var normalizeComponent = __webpack_require__(63)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b41249d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "resource/img/qrcode.jpg?43de718f8486e32035e6bd04b89eebf6";

/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Head_vue__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1c431da_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Head_vue__ = __webpack_require__(644);
function injectStyle (ssrContext) {
  __webpack_require__(641)
}
var normalizeComponent = __webpack_require__(63)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e1c431da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Head_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1c431da_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Head_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(642);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(34)("5a38bd92", content, true);

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".login-link[data-v-e1c431da]{display:none}#goLogin:hover a[data-v-e1c431da]:first-child{color:#ee7532}#goLogin:hover a[data-v-e1c431da]:first-child:after,#goLogin:hover a[data-v-e1c431da]:first-child:before{opacity:1;-webkit-transform:translateY(0);-moz-transform:translateY(0);transform:translateY(0)}#goLogin:hover .login-link[data-v-e1c431da]{display:block;position:absolute;width:210px;left:50%;margin-left:-100px!important;text-align:center}#goLogin:hover .login-link[data-v-e1c431da]:after,#goLogin:hover .login-link[data-v-e1c431da]:before{display:none}#goLogin:hover .login-link[data-v-e1c431da]:last-child{top:68px}#site img[data-v-e1c431da]{display:inline-block;width:16px;height:16px;margin-right:8px;margin-top:-1px}#site:hover a[data-v-e1c431da]:first-child{color:#ee7532}#site:hover a[data-v-e1c431da]:first-child:after,#site:hover a[data-v-e1c431da]:first-child:before{opacity:1;-webkit-transform:translateY(0);-moz-transform:translateY(0);transform:translateY(0)}#site:hover .login-link[data-v-e1c431da]{display:block;position:absolute;width:210px;left:50%;margin-left:-100px!important;text-align:center}#site:hover .login-link[data-v-e1c431da]:after,#site:hover .login-link[data-v-e1c431da]:before{display:none}", ""]);

// exports


/***/ }),

/***/ 643:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var browserLan = navigator.language === 'en' ? 'en-US' : 'zh-CN';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Head",
  data: function data() {
    return {
      isActive: false,
      uaeSiteUrl: 'https://www.orangeconnex.ae',
      jpSiteUrl:  false ? 'https://jp-test.orangeconnex.com/?from=cn' : 'https://www.orangeconnex.jp/?from=cn',
      language: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('language') === undefined ? browserLan : __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('language'),
      defaultLanguage: 'zh-CN'
    };
  },

  computed: {
    languageText: function languageText() {
      if (this.language === 'zh-CN') {
        return 'English';
      } else {
        return '中文';
      }
    }
  },
  methods: {
    toggleLang: function toggleLang() {
      if (this.language === 'zh-CN') {
        // this.languageText  = 'English';
        this.$i18n.locale = 'en-US';
        this.language = 'en-US';
      } else {
        // this.languageText  = '中文';
        this.$i18n.locale = 'zh-CN';
        this.language = 'zh-CN';
      }
      this.$store.dispatch('getNewsList', { language: this.$i18n.locale });
      this.$store.dispatch('loadContinents', { language: this.$i18n.locale });
      if (this.$route.query && this.$route.query.language) {
        //设置语言
        this.$i18n.locale = this.$route.query.language === 'en' ? 'zh-CN' : 'en-US';
        //切换了值但是url没有变化,是因为是同一个vue页面组件
        this.$route.query.language = this.$route.query.language === 'en' ? 'cn' : 'en';
        //设置最新的语言
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('language', this.$i18n.locale);
      } else {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('language', this.$i18n.locale);
        // location.reload();
      }
    }
  },
  created: function created() {
    var _this = this;

    document.addEventListener('click', function (e) {
      var sp = _this.$refs.navWill;
      if (event.target) {
        _this.isActive = !_this.isActive;
      }
    });
  }
});

/***/ }),

/***/ 644:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head"},[_c('nav',{staticClass:"navbar navbar-default container"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{ref:"navWill",staticClass:"collapse navbar-collapse nav-wil",class:{ active: _vm.isActive },attrs:{"id":"bs-example-navbar-collapse-1"}},[_c('ul',{staticClass:"nav navbar-nav fadeInDown animated"},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_c('span',[_vm._v(_vm._s(_vm.$t('global.Home')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"news"}},[_c('span',[_vm._v(_vm._s(_vm.$t('global.News')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"tracking"}},[_c('span',[_vm._v(_vm._s(_vm.$t('global.Tracking')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"product-list"}},[_c('span',[_vm._v(_vm._s(_vm.$t('global.Products')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"help"}},[_c('span',[_vm._v(_vm._s(_vm.$t('global.Help')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"about"}},[_c('span',[_vm._v(_vm._s(_vm.$t('global.About')))])])],1),_vm._v(" "),_c('li',{attrs:{"id":"site"}},[_c('a',[_c('span',[_c('img',{attrs:{"src":__webpack_require__(645),"alt":""}}),_vm._v(_vm._s(_vm.$t('global.cnSite')))])]),_vm._v(" "),_c('a',{staticClass:"login-link",attrs:{"href":_vm.jpSiteUrl}},[_c('span',[_c('img',{attrs:{"src":__webpack_require__(646),"alt":""}}),_vm._v(_vm._s(_vm.$t('global.jpSite')))])]),_vm._v(" "),_c('a',{staticClass:"login-link",staticStyle:{"top":"65px"},attrs:{"href":_vm.uaeSiteUrl}},[_vm._m(1,false,false)])]),_vm._v(" "),_c('li',{staticClass:"lang"},[_c('a',[_c('span',{on:{"click":_vm.toggleLang}},[_vm._v(_vm._s(_vm.languageText))])])]),_vm._v(" "),_c('li',{attrs:{"id":"goLogin"}},[_c('a',[_c('span',[_vm._v(_vm._s(_vm.$t('global.Login')))])]),_vm._v(" "),_c('a',{staticClass:"login-link",attrs:{"target":"_blank","href":"https://edis.ebay.com/login"}},[_c('span',[_vm._v(_vm._s(_vm.$t('global.SPKLogin')))])]),_vm._v(" "),_c('a',{staticClass:"login-link",attrs:{"target":"_blank","href":"https://mc-seller.orangeconnex.com"}},[_c('span',[_vm._v(_vm._s(_vm.$t('global.MCLogin')))])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle collapsed",attrs:{"type":"button","data-toggle":"collapse","data-target":"#bs-example-navbar-collapse-1"}},[_c('span',{staticClass:"sr-only"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_c('div',{staticClass:"navbar-brand logo fadeInLeft animated",attrs:{"data-wow-delay":".5s"}},[_c('img',{attrs:{"src":__webpack_require__(647)}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{attrs:{"src":__webpack_require__(648),"alt":""}}),_vm._v("United Arab Emirates")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "resource/img/china.png?9e54bac8e67d9dff21bb124978186a4e";

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "resource/img/japan.png?a15d9a012ac07c95654b4221887ff202";

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "resource/img/logo.svg?3750b2d94f8b8cefb9cb218ea414e5d2";

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "resource/img/uae.png?cbdf2c119849d1441127cd6f47f8b97d";

/***/ }),

/***/ 649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b903e8e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(653);
function injectStyle (ssrContext) {
  __webpack_require__(650)
}
var normalizeComponent = __webpack_require__(63)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b903e8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b903e8e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(651);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(34)("4ffc5745", content, true);

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".padding0[data-v-7b903e8e]{padding:0}.width30[data-v-7b903e8e]{width:auto}", ""]);

// exports


/***/ }),

/***/ 652:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Footer",
  computed: {
    nowYear: function nowYear() {
      var myDate = new Date();
      return myDate.getFullYear() > 2018 ? '-' + myDate.getFullYear() : '';
    }
  }
});

/***/ }),

/***/ 653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"col-md-8 padding0"},[_c('div',{staticClass:"nav_bottom nav_z"},[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.$t('global.News')))]),_vm._v(" "),_c('dd',[_c('router-link',{attrs:{"to":"news"}},[_vm._v(_vm._s(_vm.$t('global.RecentActivities')))])],1),_vm._v(" "),_c('dd',[_c('router-link',{attrs:{"to":"newsCompany"}},[_vm._v(_vm._s(_vm.$t('global.CompanyNews')))])],1)]),_vm._v(" "),_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.$t('global.TrackingC')))]),_vm._v(" "),_c('dd',[_c('router-link',{attrs:{"to":"tracking"}},[_vm._v(_vm._s(_vm.$t('global.STracking')))])],1),_vm._v(" "),_c('dd',[_c('router-link',{attrs:{"to":"trackingPickup"}},[_vm._v(_vm._s(_vm.$t('global.PCoverage')))])],1),_vm._v(" "),_c('dd',[_c('router-link',{attrs:{"to":"trackingProducts"}},[_vm._v(_vm._s(_vm.$t('global.PPricing')))])],1),_vm._v(" "),_c('dd',[_c('router-link',{attrs:{"to":"trackingPackage"}},[_vm._v(_vm._s(_vm.$t('global.PSpecifications')))])],1),_vm._v(" "),_c('dd',[_c('router-link',{attrs:{"to":"trackingContrabands"}},[_vm._v(_vm._s(_vm.$t('global.Contrabands')))])],1)]),_vm._v(" "),_c('dl',[_c('dt',[_c('router-link',{attrs:{"to":"product-list"}},[_vm._v(_vm._s(_vm.$t('global.Products')))])],1)]),_vm._v(" "),_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.$t('global.Help')))]),_vm._v(" "),_c('dd',[_c('router-link',{attrs:{"to":"help"}},[_vm._v(_vm._s(_vm.$t('global.BInquiries')))])],1),_vm._v(" "),_c('dd',[_c('router-link',{attrs:{"to":"helpUser"}},[_vm._v(_vm._s(_vm.$t('global.UserManua')))])],1),_vm._v(" "),_c('dd',[_c('router-link',{attrs:{"to":"helpFAQ"}},[_vm._v(_vm._s(_vm.$t('global.FAQ')))])],1)]),_vm._v(" "),_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.$t('global.About')))]),_vm._v(" "),_c('dd',[_c('router-link',{attrs:{"to":"about"}},[_vm._v(_vm._s(_vm.$t('global.CInformation')))])],1),_vm._v(" "),_c('dd',[_c('router-link',{attrs:{"to":"aboutRecruitment"}},[_vm._v(_vm._s(_vm.$t('global.COpportunities')))])],1),_vm._v(" "),_c('dd',[_c('router-link',{attrs:{"to":"aboutContact"}},[_vm._v(_vm._s(_vm.$t('global.ContactUs')))])],1),_vm._v(" "),_c('dd',[_c('router-link',{attrs:{"to":"aboutIntegrity"}},[_vm._v(_vm._s(_vm.$t('clause.compliance')))])],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 padding0"},[_c('div',{staticClass:"clause_w"},[_c('h4',{staticStyle:{"color":"#fff","margin-bottom":"10px"}},[_vm._v(_vm._s(_vm.$t('global.SpeedPAK')))]),_vm._v(" "),_c('router-link',{attrs:{"to":"clauseConditions"}},[_vm._v(_vm._s(_vm.$t('global.TermsConditions')))]),_vm._v(" "),_c('router-link',{attrs:{"to":"clauseService"}},[_vm._v(_vm._s(_vm.$t('global.ServiceDisclaimer')))]),_vm._v(" "),_c('router-link',{attrs:{"to":"clausePrivacy"}},[_vm._v(_vm._s(_vm.$t('global.PrivacyDisclaimer')))])],1),_vm._v(" "),_c('div',{staticClass:"nav_info_w"},[_c('table',[_c('tr',{staticStyle:{"vertical-align":"top"}},[_c('td',{staticClass:"width30",attrs:{"rowspan":"2"}},[_vm._v("\n                  "+_vm._s(_vm.$t('global.Tel'))+"\n                ")]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(_vm.$t('global.TelCN'))+"\n                ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("\n                   "+_vm._s(_vm.$t('global.TelHK'))+"\n                ")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"3px 0"},attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm.$t('global.workTime')))])])]),_vm._v(" "),_c('span',[_c('a',{staticStyle:{"color":"#fff","text-decoration":"none"},attrs:{"href":"mailto:CS@orangeconnex.com?title=title1&body=body<br>new row"}},[_vm._v(_vm._s(_vm.$t('global.Mail')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 padding0"},[_c('div',{staticClass:"clause_w"},[_c('h4',{staticStyle:{"color":"#fff","margin-bottom":"10px"}},[_vm._v(_vm._s(_vm.$t('global.consolFre')))]),_vm._v(" "),_c('router-link',{attrs:{"to":"cfClauseConditions"}},[_vm._v(_vm._s(_vm.$t('global.TermsConditions')))]),_vm._v(" "),_c('router-link',{attrs:{"to":"cfClauseService"}},[_vm._v(_vm._s(_vm.$t('global.ServiceDisclaimer')))]),_vm._v(" "),_c('router-link',{attrs:{"to":"cfClausePrivacy"}},[_vm._v(_vm._s(_vm.$t('global.PrivacyDisclaimer')))])],1),_vm._v(" "),_c('div',{staticClass:"nav_info_w"},[_c('table',[_c('tr',{staticStyle:{"vertical-align":"top"}},[_c('td',{staticClass:"width30",staticStyle:{"min-width":"27px"},attrs:{"rowspan":"2"}},[_vm._v("\n                    "+_vm._s(_vm.$t('global.Tel'))+"\n                  ")]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(_vm.$t('global.cfTelCN'))+"\n                  ")])]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('span',[_c('a',{staticStyle:{"color":"#fff","text-decoration":"none"},attrs:{"href":"mailto:Speedfreight@orangeconnex.com?title=title1&body=body<br>new row"}},[_vm._v(_vm._s(_vm.$t('global.cfMail')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 padding0"},[_c('div',{staticClass:"clause_w"},[_c('h4',{staticStyle:{"color":"#fff","margin-bottom":"10px"}},[_vm._v(_vm._s(_vm.$t('product.multiChannel.title')))]),_vm._v(" "),_c('router-link',{attrs:{"to":"mcClauseConditions"}},[_vm._v(_vm._s(_vm.$t('global.TermsConditions')))]),_vm._v(" "),_c('router-link',{attrs:{"to":"mcClauseService"}},[_vm._v(_vm._s(_vm.$t('global.ServiceDisclaimer')))]),_vm._v(" "),_c('router-link',{attrs:{"to":"mcClausePrivacy"}},[_vm._v(_vm._s(_vm.$t('global.PrivacyDisclaimer')))])],1),_vm._v(" "),_c('div',{staticClass:"nav_info_w"},[_c('table',[_c('tr',{staticStyle:{"vertical-align":"top"}},[_c('td',{staticClass:"width30",attrs:{"rowspan":"1"}},[_vm._v("\n                    "+_vm._s(_vm.$t('global.Tel'))+"\n                ")]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(_vm.$t('global.TelCN'))+"\n                  ")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"3px 0"},attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm.$t('global.workTime')))])])]),_vm._v(" "),_c('span',[_c('a',{staticStyle:{"color":"#fff","text-decoration":"none"},attrs:{"href":"mailto:CS@orangeconnex.com?title=title1&body=body<br>new row"}},[_vm._v(_vm._s(_vm.$t('global.Mail')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 copyright"},[_c('span',[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticStyle:{"line-height":"20px"}},[_vm._m(2,false,false),_vm._v(" "),_c('span',{staticStyle:{"display":"inline-block"}},[_vm._v("©2018"+_vm._s(_vm.nowYear))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('global.CopyRight'))),_c('a',{staticStyle:{"color":"#FFFFFF"},attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("闽ICP备18018224号-4")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 qrcode"},[_c('img',{attrs:{"src":__webpack_require__(638),"alt":""}}),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.$t('global.Wechat')))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2"},[_c('img',{staticClass:"bottom_logo",attrs:{"src":__webpack_require__(654),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"target":"_blank","href":"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502005284"}},[_c('img',{staticStyle:{"float":"left","display":"inline-block"},attrs:{"src":__webpack_require__(655)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{staticStyle:{"color":"#FFFFFF"},attrs:{"href":"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502005284","target":"_blank"}},[_vm._v("沪公网安备 31010502005284号 ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "resource/img/bottom_logo.png?9cc1d4581a6d3b393a5edb5178ca69f8";

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "resource/img/record.png?093bd1419b367cf6f5324f07b9abdd31";

/***/ }),

/***/ 658:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Head__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer__ = __webpack_require__(649);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Layout",
  components: {
    MainHead: __WEBPACK_IMPORTED_MODULE_0__Head__["a" /* default */],
    MainFooter: __WEBPACK_IMPORTED_MODULE_1__Footer__["a" /* default */]
  }
});

/***/ }),

/***/ 659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MainHead'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('MainFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// resource/js/2.870087d646d0078e7a34.js